import { IColumns } from '../../../../../components/Dashboard/TableSmall'

export interface IData {
  columns: IColumns[]
}

export const data: IData = {
  columns: [
    {
      id: 'asset',
      label: 'SYMBOL',
      format: (value) => value,
    },
    {
      id: 'amount',
      label: 'BALANCE',
      format: (value) => value || '0.00',
    },
  ],
}
